import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, ArrowUpRight } from "lucide-react";
import { http } from "@/lib/api";
import { fmtDue } from "@/components/dashboard/CourseWork";

const TONE = { A: "bg-[#E1F1E7] text-[#2E7D4F] border-[#B9DEC7]", B: "bg-[#E3EEF9] text-[#1F5C99] border-[#BCD4EE]", C: "bg-[#FBF0D9] text-[#8A5A00] border-[#EED9A8]", F: "bg-[#FBE4E1] text-[#A33224] border-[#F0C2BB]" };

export const KidGrades = ({ kid }) => {
  const [d, setD] = useState(null);
  useEffect(() => { http.get(`/students/${kid.id}/grades`).then((r) => setD(r.data)).catch(() => {}); }, [kid.id]);
  if (!d) return null;
  return (
    <section className="mt-5" data-testid={`parent-grades-${kid.id}`}>
      <div className="flex items-center gap-2">
        <p className="text-xs uppercase tracking-widest text-stone-500 flex-1 inline-flex items-center gap-1.5"><GraduationCap className="w-4 h-4" /> Grades · last 120 days</p>
        <Link to={`/coursework/${kid.id}`} data-testid={`parent-coursework-link-${kid.id}`} className="text-sm text-[#C87D53] inline-flex items-center gap-1">Full course work <ArrowUpRight className="w-4 h-4" /></Link>
      </div>
      {!d.subjects.length ? <p className="text-sm text-stone-500 mt-2">No quiz scores yet.</p> : (
        <>
          <div className="mt-2 flex flex-wrap gap-2">
            {d.subjects.map((s) => (
              <div key={s.subject_id} className={`rounded-2xl border px-4 py-2 ${TONE[s.letter]}`} data-testid={`parent-grade-${kid.id}-${s.subject_id}`}>
                <p className="text-[11px] uppercase tracking-wider opacity-80">{s.subject}</p>
                <p className="font-display text-2xl">{s.letter} <span className="text-base">{s.average}%</span></p>
              </div>
            ))}
          </div>
          <ul className="mt-3 divide-y divide-[#EEE8DA] rounded-2xl bg-white border border-[#E6DEC3]" data-testid={`parent-recent-${kid.id}`}>
            {d.recent.map((r) => (
              <li key={r.id} className="flex flex-wrap items-center gap-3 px-4 py-2.5 text-sm" data-testid={`parent-recent-item-${r.id}`}>
                <span className="text-stone-500 w-24">{fmtDue(r.date)}</span>
                <span className="flex-1 min-w-[160px] text-[#2C4A3E]">{r.topic} <span className="text-xs text-stone-500">· {r.subject}</span></span>
                <b className="text-[#2C4A3E]">{r.score}/{r.total} · {r.percent}%</b>
                {r.points && r.points_earned != null && <span className={r.late ? "text-[#9A5B13]" : "text-stone-600"}>{r.late ? `Late · ${r.points_raw ?? r.points_earned}/${r.points} → ${r.points_earned} pts` : `${r.points_earned}/${r.points} pts`}</span>}
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
};
